import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ImprovementActions, NavigateActions } from '../../redux/actions';

import Step1 from './Step1';
import { Step2 } from './Step2';
import ROUTES from '../../constants/RouteConstants';

class WebToolOne extends Component {

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname === ROUTES.EXPLORER && prevProps.location.pathname === ROUTES.EXPLORER_STEP1) {
      this.props.navigate(ROUTES.BASE);
    }
  }

  render() {
    const { cpiConfig, navigate, improvements, reset, appendImprovement, deleteImprovement, updateImprovement, goToStep2, location, currentStep, goToStep1, submitStep1, continueState } = this.props;
    const path = location.pathname.concat(location.hash);

    if (path === ROUTES.EXPLORER1) {
      return (
        <Step1
          navigate={navigate}
          improvements={improvements}
          appendImprovement={appendImprovement}
          deleteImprovement={deleteImprovement}
          updateImprovement={updateImprovement}
          goToStep2={goToStep2}
          submitStep1={submitStep1}
          continueClicked={continueState}
        />
      );
    } else if (path === ROUTES.EXPLORER_STEP1) {
      goToStep1();
      return (
        <Step1
          navigate={navigate}
          improvements={improvements}
          appendImprovement={appendImprovement}
          deleteImprovement={deleteImprovement}
          updateImprovement={updateImprovement}
          goToStep2={goToStep2}
          submitStep1={submitStep1}
          continueClicked={continueState}
        />
      );
    } else if (path === ROUTES.EXPLORER_STEP2 && currentStep === 2) {
      //only if user has hit continue button, do we go to step 2
      return <Step2 cpiConfig={cpiConfig} improvements={improvements} goToStep1={goToStep1} navigate={navigate} reset={reset} updateImprovement={updateImprovement} />;
    } else {
      //if user enters route manually, they should be brought back to step 1.
      navigate(ROUTES.EXPLORER_STEP1);
      return (
        <Step1
          navigate={navigate}
          improvements={improvements}
          appendImprovement={appendImprovement}
          deleteImprovement={deleteImprovement}
          updateImprovement={updateImprovement}
          goToStep2={goToStep2}
          submitStep1={submitStep1}
          continueClicked={continueState}
        />
      );
    }
  }

  componentWillUnmount() {
    const { location, navigate } = this.props;
    const path = location.pathname.concat(location.hash);

    if ((path !== ROUTES.WEBTOOL1_STEP2 && path !== ROUTES.WEBTOOL1_STEP2) || path === ROUTES.EXPLORER1) {
      navigate(ROUTES.EXPLORER_STEP1);
    }
  }
}

const mapStateToProps = (state) => {
  return {
    currentStep: state.improvements.currentStep,
    improvements: state.improvements.list,
    continueState: state.improvements.continueClicked,
    cpiConfig: state.config.cpiConfig,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      appendImprovement: ImprovementActions.appendImprovement,
      deleteImprovement: ImprovementActions.deleteImprovement,
      updateImprovement: ImprovementActions.updateImprovement,
      goToStep1: ImprovementActions.goToStep1,
      goToStep2: ImprovementActions.goToStep2,
      submitStep1: ImprovementActions.submitStep1,
      reset: ImprovementActions.resetImprovements,
      navigate: NavigateActions.navigate,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(WebToolOne);